module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jwOtU"))).then(() => parcelRequire('f4eak'));